




import Vue from 'vue';

import { Component, Prop, Watch } from 'vue-property-decorator';
import { audioCtx, sampleRate } from '@/audioGlobal';

@Component
export default class Oscilloscope extends Vue {
    @Prop(Boolean) isPlaying?: boolean;
    @Prop(AudioNode) sourceNode?: AudioNode;

    plotPoints = 128;
    baseFreq = 440;
    fftSize = 8192;
    analyser: AnalyserNode = new AnalyserNode(audioCtx, {
        minDecibels: -60,
        maxDecibels: -25,
        fftSize: this.fftSize,
        smoothingTimeConstant: 0
    });

    maxSampFreq = sampleRate / 2;
    minFreq = this.baseFreq / 2;
    maxFreq = this.baseFreq * 8;
    bufferLength = this.fftSize / 2;

    @Watch('isPlaying')
    onPlayingStatusChanged(newVal: boolean) {
        if (newVal) this.draw();
    }

    connect() {
        this.sourceNode?.connect(this.analyser);
        this.analyser.connect(audioCtx.destination);
    }

    draw() {
        this.connect();
        const freqList = new Array(2 * this.plotPoints + 1);
        for (let i = 0; i < 2 * this.plotPoints; i++) {
            freqList[i] = Math.exp(
                Math.log(this.minFreq) +
                    (i / (2 * this.plotPoints)) *
                        Math.log(this.maxFreq / this.minFreq)
            );
        }
        const indexList = new Array(this.plotPoints + 1);
        for (let i = 0; i <= this.plotPoints; i++) {
            indexList[i] = Math.round(
                (freqList[2 * i] / this.maxSampFreq) * this.bufferLength
            );
        }

        const dataArray: Uint8Array = new Uint8Array(this.bufferLength);

        const canvas = this.$refs.canvas as HTMLCanvasElement;
        const canvasCtx = canvas.getContext('2d') as CanvasRenderingContext2D;
        const { width, height } = canvas;
        canvasCtx.fillStyle = 'white';
        canvasCtx.lineWidth = 1;
        canvasCtx.strokeStyle = 'black';

        const drawNextFrame = () => {
            requestAnimationFrame(drawNextFrame);
            canvasCtx.fillRect(0, 0, width, height);

            this.analyser.getByteFrequencyData(dataArray);

            canvasCtx.beginPath();
            for (let i = 0; i < this.plotPoints; i++) {
                let sum = 0;
                for (let j = indexList[i]; j < indexList[i + 1]; j++)
                    sum += dataArray[j];
                const y =
                    (sum / (indexList[i + 1] - indexList[i]) / 256) * height;
                const x = ((i + 0.5) / this.plotPoints) * width;
                if (i === 0) {
                    canvasCtx.moveTo(x, height - y);
                } else {
                    canvasCtx.lineTo(x, height - y);
                }
            }
            canvasCtx.stroke();
        };
        requestAnimationFrame(drawNextFrame);
    }
}
